import { DatePickerStyles } from './globalStyles/datePickerStyles.styled';
import { GlobalStyle } from './globalStyles/globalStyle.styled';
import { VacationStyles } from './globalStyles/vacationStyles.styled';
import { SearchBoxStyles } from './globalStyles/serachBoxStyles.styled';

export const TimeoffTabStyles = () => {
  return (
    <>
      <GlobalStyle />
      <VacationStyles />
      <DatePickerStyles />
      <SearchBoxStyles />
    </>
  );
};
